// extracted by mini-css-extract-plugin
var _1 = "TableHeader_center__0qrH6";
var _2 = "TableHeader_headerRow__Fd-hm";
var _3 = "TableHeader_left__DJaTB";
var _4 = "TableHeader_right__7l6uH";
export { _1 as "center", _2 as "headerRow", _3 as "left", _4 as "right" }
